import { AvailabilityState } from '../../enums/index.js';
const isOnStock = (availabilityState) => {
    return availabilityState === AvailabilityState.OnStock;
};
const isPreOrder = (availabilityState) => {
    return availabilityState === AvailabilityState.PreOrder;
};
const isOutOfStock = (availabilityState) => {
    return availabilityState === AvailabilityState.OutOfStock;
};
const isTemporaryOutOfStock = (availabilityState) => {
    return availabilityState === AvailabilityState.TemporaryOutOfStock;
};
const isNotAvailableOnline = (availabilityState) => {
    return isOutOfStock(availabilityState) || isTemporaryOutOfStock(availabilityState);
};
export const StoreStockAvailability = {
    isOnStock,
    isPreOrder,
    isOutOfStock,
    isTemporaryOutOfStock,
    isNotAvailableOnline,
};
//# sourceMappingURL=storeStockAvailability.js.map